import { createFromIconfontCN } from '@ant-design/icons'
import { ICONFONT_SCRIPT_URL } from './iconfontScriptUrl'
import cls from 'classnames'
import styles from './AIcon.module.less'

const IconFont = createFromIconfontCN({ scriptUrl: [ICONFONT_SCRIPT_URL] })

const COMPONENT_NAME = 'A-Icon'
interface Props {
  type: string
  width?: number
  height?: number
  className?: string
  style?: React.CSSProperties
}

function AIcon(props: Props) {
  return (
    <IconFont
      className={cls(styles[COMPONENT_NAME], props.className)}
      style={{ ...props.style, width: props.width, height: props.height }}
      type={props.type}
    />
  )
}

export default AIcon
